import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Loader2, Save } from "lucide-react";

export const ReminderDaysCard = () => {
  const [cfg, setCfg] = useState(null);
  const [days, setDays] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/settings/petition-reminder").then((r) => { setCfg(r.data); setDays(String(r.data.days)); })
      .catch(() => { setCfg({ days: 30, overdue_count: 0 }); setDays("30"); toast.error("Hatırlatma ayarı yüklenemedi"); });
  }, []);

  const save = async () => {
    const n = Number(days);
    if (!Number.isInteger(n) || n < 1 || n > 365) { toast.error("1 ile 365 arasında bir gün sayısı girin"); return; }
    setBusy(true);
    try {
      const r = await api.put("/settings/petition-reminder/days", { days: n });
      setCfg(r.data);
      toast.success("Gün sınırı kaydedildi");
    } catch (e) { toast.error("Kaydedilemedi"); }
    finally { setBusy(false); }
  };

  return (
    <Card className="p-6 border border-slate-200 shadow-sm max-w-2xl mt-6" data-testid="reminder-days-card">
      <h3 className="font-display font-semibold text-slate-900">Dilekçe Hatırlatma Gün Sınırı</h3>
      <p className="text-sm text-slate-500 mt-1">
        Beklemede veya işlemde olan bir dilekçe bu kadar günden uzun süredir bekliyorsa haftalık hatırlatma e-postasına girer.
      </p>
      {!cfg ? <div className="text-sm text-slate-500 mt-4">Yükleniyor...</div> : (
        <>
          <div className="mt-4">
            <Label>Gün sayısı</Label>
            <div className="flex flex-wrap items-center gap-2 mt-1">
              <Input type="number" min={1} max={365} value={days} onChange={(e) => setDays(e.target.value)}
                     className="w-28" data-testid="reminder-days-input" />
              <span className="text-sm text-slate-500">gün</span>
              <Button onClick={save} disabled={busy} className="bg-emerald-700 hover:bg-emerald-800" data-testid="reminder-days-save-button">
                {busy ? <Loader2 className="h-4 w-4 mr-1.5 animate-spin" /> : <Save className="h-4 w-4 mr-1.5" />} Kaydet
              </Button>
            </div>
          </div>
          <div className="text-sm mt-3" data-testid="reminder-days-overdue-count">
            Şu an {cfg.days} günden uzun bekleyen dilekçe: <span className="font-semibold text-slate-900">{cfg.overdue_count ?? 0}</span>
          </div>
        </>
      )}
    </Card>
  );
};
